Vue.asyncComponent('cms-account-menu', {
    data() {
        return {
            show: false,
            user: this.$userInterfaceHandler.getUserInterface()?.user,
            avatar: this.$userInterfaceHandler.getUserInterface()?.avatar,
            menu: this.$userInterfaceHandler.getUserInterface()?.menuUser
        }
    },
    watch: {
        '$userInterfaceHandler.userInterface': {
            handler() {
                this.user =  this.$userInterfaceHandler.getUserInterface()?.user;
                this.avatar =  this.$userInterfaceHandler.getUserInterface()?.avatar;
                this.menu =  this.$userInterfaceHandler.getUserInterface()?.menuUser;
            }, deep: true
        }
    },
    methods: {
        closeMenu() {
            this.show = false;
        }
    }
}, 'cms/account/cms-account-menu.html');